import React, {useRef, useState} from 'react';
import Component from '../MgyComponent';
import Form from '../MgyForm';
import InputField from "../MgyInputField";
import Button from "../MgyButton";
import {Input} from "@progress/kendo-react-inputs";
import {Error} from "@progress/kendo-react-labels";
import LoadingIndicator from "../MgyLoading";
import './MgyLandingLoginForm.css';
import moment from 'moment'

/**
 * Form for landing
 *
 * @param logo
 * @param className
 * @param handlerSubmit
 * @param rest
 * @returns {*}
 * @constructor
 */
export default function MgyLandingLoginForm({logo, className, handlerSubmit, ...rest}) {

	const [showLoader, setShowLoader] = useState(false);
	const [validationMessage, setValidationMessage] = useState("");
	const networkIdElement = "networkId-" + moment().format('YYYYMMDDHHmmss');
	const nidRef = useRef(null);

	// on submit
	const handleSubmit = (data) => {
		const v = nidRef.current.props.value; // const strNid = data[networkIdElement];
		const nid = parseInt(v); // parseInt(strNid);
		data.networkId = v;

		if (nid >= 10000 && nid <= 99999) {
			setValidationMessage("");
			return handlerSubmit(data, setShowLoader);
		}

		setValidationMessage("Network Id must have 5 digits");
		return false;
	};

	// nid validation event
	const handleCheckNID = (e) => {
		const k = e.key;
		const f = (",1,2,3,4,5,6,7,8,9,0,Home,Backspace,ArrowLeft,ArrowRight,").indexOf("," + k.toString() + ",");
		if (f === -1) {
			e.preventDefault();
			return false;
		}
	};

	// empty field checker
	const checkFieldRequired = () => {
		const v = nidRef.current.props.value;
		if (v === undefined || v === null || v === "") {
			setValidationMessage('Network Id is required');
		}
	}

	// sub-components
	const NIDInput = ({validationMessage, visited, ...props}) => (
		<div>
			<Input ref={nidRef} maxLength={5} onKeyDown={handleCheckNID} onPaste={(e) => {
				e.preventDefault();
				return false;
			}} {...props} />
		</div>
	);

	const Column = (props) => <div className={"col col-12"} {...props} />
	const Row = ({className, ...props}) => <div className={"row " + (className ?? '')} {...props} />

	// render
	return (
		<Component className="login-form">
			<Form className={"mgy-login-form " + (className ?? '')} handlerSubmit={handleSubmit} {...rest}>
				<Row className={"login-form-instance centered"}>
					<Column>
						<Row>
							<Column>
								<img src={logo} alt={"logo"}/>
								<h1 className={"margin-top-50"}>Sign in</h1>
								<p>Enter your Magaya Network ID</p>
							</Column>
						</Row>
						<Row>
							<Column>
								{validationMessage && <Error>{validationMessage}</Error>}
								<InputField name={networkIdElement} label={"Network Id"} className={"mgy-full-width"} component={NIDInput}/>
							</Column>
						</Row>
						<Row>
							{showLoader ? <Column id={"loading-indicator-section"}><LoadingIndicator/></Column> :
								<Column>
									<Button primary type="submit" className={"mgy-full-width"} label={"Continue"} onClick={checkFieldRequired}/>
								</Column>}
						</Row>
					</Column>
				</Row>
			</Form>
		</Component>
	);
};
